import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import Cookies from 'universal-cookie';
import cookie from './img/cookie.svg'
import dayjs from 'dayjs';
import "./Cookie.scss"

export const ACCEPT_COOKIE = 'accept_cookie'

const Cookie = ({ setIsModal }) => {
    const cookies = new Cookies()

    const handleAcceptCookies = () => {
        cookies.set(ACCEPT_COOKIE, "yes", { path: '/', expires: dayjs().add(1, 'year').toDate() })
        setIsModal(false)
    }

    return (
        <div className='cookie'>
            <img className='cookie__img' src={cookie} alt='icon' />
            <p className='cookie__text'>Мы используем Cookie </p>
            <ButtonBasic
                width='100px'
                minWidth='100px'
                blue
                onClick={handleAcceptCookies}
                text='Ок'
            />
        </div>
    )
}

export { Cookie }